export const selectContacts = state => state.contacts;
